/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".connection-input{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.settings-language-selector .text-label mat-icon{width:42px;height:24px}.mat-checkbox-warning{font-size:.7em}"];
export { styles as styles };
